'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

exports.default = reverse;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reverse(_ref) {
    var series = _ref.series,
        seriesNormalized = _ref.seriesNormalized,
        minX = _ref.minX,
        maxX = _ref.maxX,
        maxY = _ref.maxY,
        minY = _ref.minY;

    series = (0, _isArray3.default)(series) ? (0, _cloneDeep3.default)(series).reverse() : series;
    return {
        series: series,
        seriesNormalized: seriesNormalized,
        maxX: maxX,
        maxY: maxY,
        minX: minX,
        minY: minY
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/helpers/transforms/reverse.js
// module id = 1463
// module chunks = 0